const productcategory = {
    getlist: 'productcategory/getlist',
    add: 'productcategory/add',
    update: 'productcategory/update',
    remove: 'productcategory/remove',
    get: 'productcategory/get-by-admin',
    getall: 'productcategory/getall',
    clearcache: 'productcategory/clear-cache',
}
export default productcategory
